var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoReal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-real",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.949,
    height: 43.951,
    viewBox: "0 0 43.949 43.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 43.949,
    height: 43.951,
    fill: "#003761"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.4 17.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.311,9.1,2.352,0H0L3,5.425H.068v1.8H3.994L5.026,9.1Z",
    transform: "translate(20.189 0.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.946,7.245V0H0V9.116H6.431V7.245Z",
    transform: "translate(28.702 0.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M1.929,5.477H6.245V3.623H1.929V1.871H7.463V0H0V9.116H7.463V7.245H1.929Z",
    transform: "translate(10.306 0.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M6.058,9.082,4.688,6.438H1.76L.8,4.567H4.586A1.433,1.433,0,0,0,6.143,3.193a1.346,1.346,0,0,0-1.32-1.356H1.9V9.082H0V0H4.975a3.208,3.208,0,0,1,3.2,3.142A2.944,2.944,0,0,1,6.617,5.8L8.36,9.1h-2.3Z",
    transform: "translate(0.017 0.137)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReal);
export default __webpack_public_path__ + "static/media/logo-real.5d1eeaa0a47922267e2a69c195d627e2.svg";
export { ForwardRef as ReactComponent };